import { useThingSpeakFormattedData } from "../../../respository/agristick";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const ThingspeakCard = () => {
  const { data, loading, error } = useThingSpeakFormattedData({
    channelId: 1548738,
    field4: 1, // Leaf Wetness
    field1: 2, // Soil Moisture
    results: 5,
  });

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading data.</div>;

  // Format the data for Recharts
  const formattedData = data.map((entry: any) => ({
    time: entry.time.split(" ")[0], // HH:MM:SS from "15:40:00 GMT+0530"
    ["Leaf Wetness"]: parseInt(entry.leafWetness.split(": ")[1], 10),
    ["Soil Moisture"]: parseInt(entry.soilMoisture.split(": ")[1], 10),
  }));

  console.log(formattedData);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "40px" }}>
      <h3>Soil Moisture Over Time</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={formattedData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="time" />
          {/* <YAxis label={{ value: "%", angle: -90, position: "insideLeft" }} /> */}
          <YAxis label={{ value: "%", angle: -90, position: "insideLeft" }} />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="Soil Moisture"
            stroke="#2e7d32"
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>

      <h3>Leaf Wetness Over Time</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={formattedData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="time" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="Leaf Wetness"
            stroke="#c62828"
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ThingspeakCard;
